/**
 * @generated SignedSource<<24a98c8d368e3562c792e12d463cfa69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTopicWidgetQuery$data = {
  readonly advertConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly topic: {
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"hooksTopic" | "topicAdsTopic" | "topicMetadataDisplayTopic">;
  };
  readonly " $fragmentType": "hooksTopicWidgetQuery";
};
export type hooksTopicWidgetQuery$key = {
  readonly " $data"?: hooksTopicWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTopicWidgetQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksTopicWidgetQuery"
};

(node as any).hash = "72c4bb3a07f0999cc5e65df41ce2c120";

export default node;
